import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { scoreCardApiRef } from '../api';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';

export type NpsScoreResponse = {
  score: number;
  date: string;
  details: number;
};

export const useNpsScore = () => {
  const [score, setScore] = useState(0);
  const [date, setDate] = useState('');
  const [responses, setResponses] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { entity } = useEntity();
  const entityRef = stringifyEntityRef(entity);
  const api = useApi(scoreCardApiRef);

  useEffect(() => {
    setLoading(true);
    api
      .getNPSScore(entityRef)
      .then((res:NpsScoreResponse) => {
        
        setScore(res?.score ?? 0);
        setDate(res?.date ?? '');
        setResponses(res?.details ?? 0);
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [entityRef, api]);

  return { score, date, responses, loading, error };
};
